export function Page({ children, className = "", wide = false }) {
  return (
    <div className={`${wide ? "max-w-[1600px]" : "max-w-7xl"} mx-auto px-4 sm:px-8 py-8 sm:py-12 animate-fade-up ${className}`}>
      {children}
    </div>
  );
}

export function PageTitle({ eyebrow, title, subtitle, right }) {
  return (
    <div className="flex items-end justify-between gap-4 mb-8">
      <div>
        {eyebrow && (
          <div className="text-[11px] uppercase tracking-[0.25em] text-[#E5B842] font-mono font-bold mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-heading text-4xl sm:text-5xl font-black uppercase tracking-tight text-slate-50 leading-none">
          {title}
        </h1>
        {subtitle && <p className="text-slate-400 mt-2 text-sm sm:text-base max-w-2xl">{subtitle}</p>}
      </div>
      {right}
    </div>
  );
}

export function Card({ children, className = "", ...rest }) {
  return (
    <div
      className={`rounded-xl bg-[#0f0f0f] border border-[rgba(212,175,55,0.20)] ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function Stat({ label, value, Icon }) {
  return (
    <Card className="p-5">
      <div className="flex items-center justify-between">
        <div className="text-[11px] uppercase tracking-[0.2em] text-slate-500 font-mono">{label}</div>
        {Icon && <Icon className="w-4 h-4 text-[#E5B842]" />}
      </div>
      <div className="font-heading text-3xl font-black text-slate-50 mt-2 tabular-nums">{value}</div>
    </Card>
  );
}

export function Loader({ label = "Loading registry…" }) {
  return (
    <div className="flex items-center justify-center py-24 text-slate-500 font-mono text-sm uppercase tracking-widest">
      {label}
    </div>
  );
}

export function Empty({ label }) {
  return (
    <div className="text-center py-20 text-slate-500 font-mono text-sm uppercase tracking-widest border border-dashed border-[rgba(212,175,55,0.25)] rounded-xl">
      {label}
    </div>
  );
}

export function GoldButton({ children, className = "", ...rest }) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-bold uppercase tracking-wide bg-[#E5B842] text-[#000000] hover:bg-[#C99E30] disabled:opacity-40 disabled:cursor-not-allowed ${className}`}
      style={{ transition: "background-color 0.15s ease" }}
      {...rest}
    >
      {children}
    </button>
  );
}

export function Skeleton({ className = "" }) {
  return <div className={`animate-pulse rounded-md bg-[#2b2512]/60 ${className}`} />;
}

export function RowsSkeleton({ rows = 8 }) {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-8 sm:py-12" data-testid="page-skeleton">
      <Skeleton className="h-4 w-40 mb-4" />
      <Skeleton className="h-10 w-72 mb-8" />
      <div className="rounded-xl bg-[#0f0f0f] border border-[rgba(212,175,55,0.20)] p-4 space-y-3">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex items-center gap-4">
            <Skeleton className="h-10 w-10 shrink-0 rounded-lg" />
            <Skeleton className="h-5 flex-1" />
            <Skeleton className="h-5 w-20 hidden sm:block" />
            <Skeleton className="h-5 w-16" />
          </div>
        ))}
      </div>
    </div>
  );
}

export function GhostButton({ children, className = "", ...rest }) {
  return (
    <button
      className={`inline-flex items-center justify-center gap-2 px-4 py-2 rounded-lg text-sm font-semibold bg-[#161616] border border-[rgba(212,175,55,0.25)] text-slate-200 hover:border-[#E5B842]/60 hover:text-[#E5B842] disabled:opacity-40 disabled:cursor-not-allowed ${className}`}
      style={{ transition: "border-color 0.15s ease" }}
      {...rest}
    >
      {children}
    </button>
  );
}
